import { frontendURL } from '../../../helper/URLHelper';
const SettingsWrapper = () => import('../settings/Wrapper.vue');
const KanbanView = () => import('./components/KanbanView.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/kanban'),
    name: 'kanban',
    meta: {
      permissions: ['administrator', 'agent', 'kanban_manage'],
    },
    component: SettingsWrapper,
    props: {
      headerTitle: 'Kanban',
      icon: 'alert',
      showNewButton: false,
      showSidemenuIcon: false,
      fullWidth: true,
    },
    children: [
      {
        path: '',
        redirect: to => ({ name: 'kanban_overview', params: to.params }),
      },
      {
        path: 'overview',
        name: 'kanban_overview',
        meta: {
          permissions: ['administrator', 'agent', 'kanban_manage'],
        },
        component: KanbanView,
      },
    ],
  },
];
